import { i18n } from "../../plugins/vue-i18n";

export const migrationConfigFields = [
  "source_email",
  "target_email",
  // TODO: campos de drive
  // "target_drive_email",
  "shared_with",
  "period",
];

export const labels = {
  source_email: i18n.t("migrationValidation.headerSourceEmail"),
  target_email: i18n.t("migrationValidation.headerTargetEmail"),
  // TODO: campos de drive
  // target_drive_email: i18n.t("migrationValidation.headerTargetDrive"),
  shared_with: i18n.t("migrationValidation.headerSharedWith"),
  period: i18n.t("migrationValidation.headerStartDate"),
};

export const getLabelsHistory = () => ({
  created_at: i18n.t("migrationHistory.createdAtHeader"),
  description: i18n.t("migrationHistory.descriptionHeader"),
  shared_with: i18n.t("migrationHistory.sharedWithHeader"),
  author: i18n.t("migrationHistory.authorHeader"),
  event: i18n.t("migrationHistory.eventHeader"),
  progress: i18n.t("migrationHistory.progressHeader"),
  status: i18n.t("migrationHistory.statusHeader"),
  actions: i18n.t("migrationHistory.actionsHeader"),
});

export const getMigrationValidationCode = () => ({
  ADD_TO_GROUP: {
    tooltipMessage: i18n.t("migrationTooltipMessage.ADD_TO_GROUP"),
    icon: "ph-fill ph-warning-circle",
    textColor: "amber--text",
    backgroundColor: "#fff8e1",
  },

  DEFAULT_VALUE: {
    tooltipMessage: i18n.t("migrationTooltipMessage.DEFAULT_VALUE"),
    icon: "ph-fill ph-warning-circle",
    textColor: "amber--text",
    backgroundColor: "#fff8e1",
  },

  INVALID_DATE_FORMAT: {
    tooltipMessage: i18n.t("migrationTooltipMessage.INVALID_DATE_FORMAT"),
    icon: "ph-fill ph-x-circle",
    textColor: "red--text",
    backgroundColor: "#ffebee",
  },

  INVALID_DATE_GREATER_THAN_TODAY: {
    tooltipMessage: i18n.t(
      "migrationTooltipMessage.INVALID_DATE_GREATER_THAN_TODAY"
    ),
    icon: "ph-fill ph-x-circle",
    textColor: "red--text",
    backgroundColor: "#ffebee",
  },

  NEED_CREATE: {
    tooltipMessage: i18n.t("migrationTooltipMessage.NEED_CREATE"),
    icon: "ph-fill ph-warning-circle",
    textColor: "amber--text",
    backgroundColor: "#fff8e1",
  },

  NEW_DRIVE: {
    tooltipMessage: i18n.t("migrationTooltipMessage.NEW_DRIVE"),
    icon: "ph-fill ph-warning-circle",
    textColor: "amber--text",
    backgroundColor: "#fff8e1",
  },

  NO_LICENSE: {
    tooltipMessage: i18n.t("migrationTooltipMessage.NO_LICENSE"),
    icon: "ph-fill ph-x-circle",
    textColor: "red--text",
    backgroundColor: "#ffebee",
  },

  NOT_FOUND: {
    tooltipMessage: (type) =>
      i18n.t("migrationTooltipMessage.NOT_FOUND", { type }),
    icon: "ph-fill ph-x-circle",
    textColor: "red--text",
    backgroundColor: "#ffebee",
  },

  USER_DUPLICATED: {
    tooltipMessage: i18n.t("migrationTooltipMessage.USER_DUPLICATED"),
    icon: "ph-fill ph-x-circle",
    textColor: "red--text",
    backgroundColor: "#ffebee",
  },

  INVALID_EMAIL_FORMAT: {
    tooltipMessage: i18n.t("migrationTooltipMessage.INVALID_EMAIL_FORMAT"),
    icon: "ph-fill ph-x-circle",
    textColor: "red--text",
    backgroundColor: "#ffebee",
  },

  REQUIRED_FIELD: {
    tooltipMessage: i18n.t("migrationTooltipMessage.REQUIRED_FIELD"),
    icon: "ph-fill ph-x-circle",
    textColor: "red--text",
    backgroundColor: "#ffebee",
  },

  TRIAL_LIMIT_EXCEEDED: {
    tooltipMessage: i18n.t("migrationTooltipMessage.TRIAL_LIMIT_EXCEEDED"),
    icon: "ph-fill ph-x-circle",
    textColor: "gray--text",
    backgroundColor: "#eaeaeaff",
  },

  TRIAL_PERIOD_LIMIT: {
    tooltipMessage: i18n.t("migrationTooltipMessage.TRIAL_PERIOD_LIMIT"),
    icon: "ph-fill ph-warning-circle",
    textColor: "amber--text",
    backgroundColor: "#fff8e1",
  },
});

export const getMigrationStatusCode = () => ({
  IN_PROGRESS: {
    formattedStatus: i18n.t("migrationHistory.IN_PROGRESS"),
    icon: "ph ph-clock-countdown",
    colorIcon: "blue--text text--darken-2",
  },
  CANCELED: {
    formattedStatus: i18n.t("migrationHistory.CANCELED"),
    icon: "ph ph-prohibit",
    colorIcon: "grey--text text--darken-2",
  },
  INTERRUPTED: {
    formattedStatus: i18n.t("migrationHistory.INTERRUPTED"),
    icon: "ph ph-stop-circle",
    colorIcon: "grey--text text--darken-2",
  },
  COMPLETED: {
    formattedStatus: i18n.t("migrationHistory.COMPLETED"),
    icon: "ph ph-check-circle",
    colorIcon: "success--text",
  },
  COMPLETED_WITH_ERRORS: {
    formattedStatus: i18n.t("migrationHistory.COMPLETED_WITH_ERRORS"),
    icon: "ph ph-x-circle",
    colorIcon: "error--text",
  },
  FAILED: {
    formattedStatus: i18n.t("migrationHistory.FAILED"),
    icon: "ph ph-x-circle",
    colorIcon: "error--text",
  },
  IN_QUEUE: {
    formattedStatus: i18n.t("migrationHistory.IN_QUEUE"),
    tooltipMessage: i18n.t("migrationHistory.IN_QUEUE_TOOLTIP"),
    icon: "ph ph-clock",
    colorIcon: "grey--text text--darken-2",
  },
});

export const getMigrationEventCode = () => ({
  ADD_TO_GROUP: {
    formattedEvent: i18n.t("migrationHistory.ADD_TO_GROUP"),
    description: (source_user, destination_group) =>
      i18n.t("migrationHistory.add_to_group_description", {
        source_user,
        destination_group,
      }),
  },
  DRIVE: {
    formattedEvent: i18n.t("migrationHistory.DRIVE"),
    description: (source_user, destination_group) =>
      i18n.t("migrationHistory.drive_description", {
        source_user,
        destination_group,
      }),
  },
  EMAIL_TO_GROUP: {
    formattedEvent: i18n.t("migrationHistory.EMAIL_TO_GROUP"),
    description: (source_user, destination_group) =>
      i18n.t("migrationHistory.migration_description", {
        source_user,
        destination_group,
      }),
  },
  REMOVE_LICENSE: {
    formattedEvent: i18n.t("migrationHistory.REMOVE_LICENSE"),
    description: (source_user, destination_group) =>
      i18n.t("migrationHistory.remove_license_description", {
        source_user,
        destination_group,
      }),
  },
});
